import React from "react";
import logo from "../../assets/booklocal-logo.gif";
import "./NavBar.css";
import { FaHome, FaInfoCircle, FaUsers, FaStethoscope, FaUserPlus, FaSignOutAlt } from 'react-icons/fa';
import { Button } from 'antd';

const NavBar = ({
  showNavLinks = true,
  showRegisterButton = true,
  showLogoutButton = false,
  showSignInButton = false,
  handleLogout,
}) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <a href="/" className="navbar-logo">
          <img src={logo} alt="Book Local" />
        </a>

        <div className="mobile-menu-icon" onClick={toggleMobileMenu}>
          <div></div><div></div><div></div>
        </div>

        <div className={`navbar-links ${isMobileMenuOpen ? "active" : ""}`}>
          {showNavLinks && (
            <>
              <a href="/"><FaHome /> Home</a>
              <a href="https://www.booklocal.co.in/about-us"><FaInfoCircle /> About Us</a>
              <a href="https://www.booklocal.co.in/for-users"><FaUsers /> For Users</a>
              <a href="https://www.booklocal.co.in/for-doctors"><FaStethoscope /> For Doctors</a>
            </>
          )}
          {showRegisterButton && (
            <a href="/register-rehab-center" className="register-button mobile-register-button">
              Register your Rehab Center
            </a>
          )}
        </div>

        {showRegisterButton && (
          <a href="/register-rehab-center" className="register-button desktop-register-button">
            Register your Rehab Center
          </a>
        )}

        {showSignInButton && (
          <a href="/rehab-dashboard" className="register-button desktop-register-button" style={{ backgroundColor: 'red', color: 'white' }}>
            Registered user, sign in here
          </a>
        )}

        {showLogoutButton && (
          <Button type="link" onClick={handleLogout} className="logout-button-navbar" icon={<FaSignOutAlt />}>
            Logout
          </Button>
        )}
      </div>
    </nav>
  );
};

export default NavBar;